module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reset":"Reset","save_params_preset":"Save Params Preset","load_params_preset":"Load Params Preset","ssp_color":"SSP Color"},"ja":{"reset":"リセット","save_params_preset":"パラメーターを保存","load_params_preset":"パラメーターを読み込み","ssp_color":"SSP色調整"}}')
  delete Component.options._Ctor
}
